import React from 'react';
import ReactEcharts from 'echarts-for-react';

const Jcbargraph = ({ data, data2 }) => {
    // console.log("Bar Graph Data:", data);
    // console.log("Box Data (data2):", data2);

    if (!Array.isArray(data) || data.length === 0) {
        return <div className="text-center text-gray-500">No data to display</div>;
    }

    const xData = data.map((item) => item.key);
    const yData = data.map((item) => item.doc_count);

    // Get values from data2 for boxes
    const getCountFromData2 = (matchKey) => {
        const found = data2?.find(
            (item) => item.key.trim().toLowerCase() === matchKey.trim().toLowerCase()
        );
        return found ? found.doc_count : 0;
    };

    const CV_Passenger = getCountFromData2("CV_Passenger");
    const ILCV = getCountFromData2("ILCV");
    const MHCV = getCountFromData2("M&HCV");
    const SCVPU = getCountFromData2("SCV & PU");

    const option = {
        tooltip: {
            trigger: 'axis',
        },
        xAxis: {
            type: 'category',
            data: xData,
            axisLabel: {
                rotate: 45,
                fontSize: 9,
            },
        },
        yAxis: {
            type: 'value',
        },
        series: [
            {
                data: yData,
                type: 'bar',
                showBackground: true,
                backgroundStyle: {
                    color: 'rgba(180, 180, 180, 0.2)',
                },
                itemStyle: {
                    color: '#4A90E2',
                },
            },
        ],
    };

    return (
        <div className="p-1">
            {/* 4 Summary Boxes */}
            <div className="flex flex-col gap-1 justify-center items-center">
                <div className="flex gap-3 ">
                    <div className="bg-[#FFFF] shadow-[0_4px_5px_-1px_rgba(59,130,206,0.5)] border w-[150px] p-3 rounded-lg  text-xs text-center text-gray-600 font-medium ">
                        CV Passenger - {CV_Passenger}
                    </div>
                    <div className="bg-[#FFFF] w-[150px] p-3 rounded-lg shadow-[0_4px_5px_-1px_rgba(59,130,206,0.5)]  border  text-xs text-center font-medium  text-gray-600">
                        ILCV - {ILCV}
                    </div>
                </div>

                <div className="flex gap-3">
                    <div className="bg-[#FFFF] w-[150px] p-3 rounded-lg border shadow-[0_4px_5px_-1px_rgba(59,130,206,0.5)]   text-xs text-center text-gray-600 font-medium ">
                        M&HCV - {MHCV}
                    </div>
                    <div className="bg-[#FFFF] w-[150px] p-3 rounded-lg border  shadow-[0_4px_5px_-1px_rgba(59,130,206,0.5)] text-xs text-center text-gray-600 font-medium ">
                        SCV & PU - {SCVPU}
                    </div>
                </div>
            </div>


            {/* Bar Graph */}
            {/* Bar Graph with Horizontal Scroll */}
            <div className="overflow-x-auto">
                <div className="min-w-[720px]">
                    <ReactEcharts option={option} style={{ height: 220, width: '100%' }} />
                </div>
            </div>
        </div >
    );
};

export default Jcbargraph;

